import { useState } from "react";
import { CoreModal } from "../core/modal/Modal";
import ThemeWrapper from "../theme";
import styles from "./installMobile.module.css";
import Lottie from "lottie-react";
import rocket from "./images/rocket.json";
import { CoreButton } from "../core/button/Button";
import { Link, Typography } from "@mui/material";
import Apple from "./images/apple.svg?react";
import Google from "./images/google.svg?react";
import lockdownIcon from "./images/lockdownIcon.svg";
import i18nPackage from "../i18n/i18n";

function isIOS() {
	// Tests for iOS device characteristics
	const iosPlatforms = ["iPhone", "iPad", "iPod"];
	const isIOSPlatform = iosPlatforms.some((platform) => navigator.platform.includes(platform));

	// Additional check for iPad on iOS 13 and above
	const isIOS13Ipad =
		navigator.userAgent.includes("Macintosh") && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;

	// Checks for iOS in user agent string for broader compatibility
	const isIOSUserAgent = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;

	return isIOSPlatform || isIOS13Ipad || isIOSUserAgent;
}

function launchApp(url: string, verityOrigin: string) {
	const encodedUrl = encodeURIComponent(url);
	const scheme = url
		? `veritymobilelockdown://browse?initialUrl=${encodedUrl}&verityOrigin=${verityOrigin}`
		: `veritymobilelockdown://home?verityOrigin=${verityOrigin}`;

	const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

	if (isSafari) {
		window.open(scheme);
	} else {
		window.location.href = scheme;
	}
}

export function InstallMobileModalContent({
	assessmentUrl,
	verityOrigin,
}: {
	assessmentUrl: string;
	verityOrigin: string;
}) {
	const isIphone = isIOS();
	const downloadUrls = [
		"https://apps.apple.com/ca/app/yuja-verity/id6480011608",
		"https://play.google.com/store/apps/details?id=com.yuja.veritymobilelockdown&hl=en_CA&gl=US",
	];
	return (
		<div className={styles.dialogContent}>
			<div className={styles.header}>
				<div className={styles.flexDirecMid}>
					<img className={styles.marginL} src={lockdownIcon} style={{ width: "110px", height: "110px" }}></img>
					<div className={styles.animation}>
						<Lottie animationData={rocket} />
					</div>
				</div>

				<Typography variant="h2" className={styles.headerText}>
					{i18nPackage.t("installMobile.launchTheVerityMobileApp")}
				</Typography>
				<CoreButton className={styles.launchBtn} onClick={() => launchApp(assessmentUrl, verityOrigin)}>
					{i18nPackage.t("installMobile.launchVerity")}
				</CoreButton>
			</div>
			<div className={styles.content}>
				<p className={styles.mainInstructions}>{i18nPackage.t("installMobile.hasNotLaunched")}</p>
				<div className={styles.section}>
					<ol className={styles.steps}>
						<li style={{ fontWeight: "500", fontSize: "13px", lineHeight: "13px" }}>
							{i18nPackage.t("installMobile.downloadMobileApp")}
							<div className={styles.flexDirec}>
								{isIphone ? (
									<CoreButton
										onClick={() => {
											window.open(downloadUrls[0], "_blank");
										}}
										style={{
											marginLeft: "0px",
											paddingLeft: "10px",
											paddingRight: "20px",
											borderRadius: "5px",
											height: "45px",
											paddingTop: "0px",
											paddingBottom: "0px",
										}}
									>
										<div className={styles.downloadBtnOverall}>
											<Apple style={{ marginRight: "10px" }} />
											<div className={styles.downloadBtnText}>
												<Typography style={{ fontSize: "10px", fontWeight: "400" }} className={styles.downloadBtnText1}>
													{i18nPackage.t("installMobile.DownloadOnThe")}
												</Typography>
												<Typography style={{ fontSize: "15px", fontWeight: "700" }} className={styles.downloadBtnText2}>
													{i18nPackage.t("installMobile.appStore")}
												</Typography>
											</div>
										</div>
									</CoreButton>
								) : (
									<CoreButton
										onClick={() => {
											window.open(downloadUrls[1], "_blank");
										}}
										style={{
											marginLeft: "0px",
											paddingLeft: "10px",
											paddingRight: "20px",
											borderRadius: "5px",
											height: "45px",
											paddingTop: "0px",
											paddingBottom: "0px",
										}}
									>
										<div className={styles.downloadBtnOverall}>
											<Google style={{ marginRight: "10px" }} />
											<div className={styles.downloadBtnText}>
												<Typography style={{ fontSize: "10px", fontWeight: "400" }} className={styles.downloadBtnText1}>
													{i18nPackage.t("installMobile.getItOn")}
												</Typography>
												<Typography style={{ fontSize: "15px", fontWeight: "700" }} className={styles.downloadBtnText2}>
													{i18nPackage.t("installMobile.googlePlay")}
												</Typography>
											</div>
										</div>
									</CoreButton>
								)}
							</div>
						</li>
						<li style={{ fontWeight: "500", fontSize: "13px", lineHeight: "13px" }}>
							{i18nPackage.t("installMobile.launchTheAppToRedirect")}
						</li>
						<li style={{ fontWeight: "500", fontSize: "13px", lineHeight: "13px" }}>
							{i18nPackage.t("installMobile.navigateToAssessment")}
						</li>
					</ol>
				</div>
				<Link className={styles.supportLink} href="https://support.yuja.com/hc/en-us" target="blank">
					{i18nPackage.t("installMobile.contactSupport")}
				</Link>
			</div>
		</div>
	);
}

export default function InstallMobilePage({
	assessmentUrl,
	verityOrigin,
}: {
	assessmentUrl: string;
	verityOrigin: string;
}) {
	const [modalShowing, setModalShowing] = useState(true);

	return (
		<ThemeWrapper>
			<CoreModal
				onClose={() => {
					window.top?.postMessage({ request: "closeModalDiv" }, "*");
					setModalShowing(false);
				}}
				open={modalShowing}
				showBottomCloseButton
			>
				<InstallMobileModalContent assessmentUrl={assessmentUrl} verityOrigin={verityOrigin} />
			</CoreModal>
		</ThemeWrapper>
	);
}
